import { BannerAreaComponent } from "./banner-area.component";
import { BannerAreaModel } from "./models/banner.model";

export class BannersDetailsComponent {
    public static SELECTOR_DESKTOP: string = ".js-ina-banners-details-desktop";
    public static SELECTOR_MOBILE: string = ".js-ina-banners-details-mobile";

    private _currentContext: JQuery = $();

    private _classMap = {
        css: {
            active: "ina-banners__area--active"
        }
    };

    private _currentBannerAreas: Array<BannerAreaModel> = [];
    private _bannerAreas: Array<BannerAreaComponent> = [];

    public get bannerId(): string {
        return this._currentContext.data().bannerId as string;
    }

    public setBanners(banners: Array<BannerAreaModel>): BannersDetailsComponent {
        this._currentBannerAreas = banners;
        return this;
    }

    public toggleActive(state: boolean): void {
        this._currentContext.toggleClass(this._classMap.css.active, state);

    }

    public destroy(): void {
        this._bannerAreas.forEach((area) => {
            area.destroy();
        });

        this._bannerAreas = [];
        this._currentContext.html(null);
    }

    private renderDetails(): Array<JQuery> {
        return this._currentBannerAreas.map(banner => {
            const bannerArea = new BannerAreaComponent();
            this._bannerAreas.push(bannerArea);
            return bannerArea.setBanner(banner).render();
        });
    }

    public render(): void {
        this.destroy();

        const bannersDetails = this.renderDetails();
        this._currentContext.append(bannersDetails);

        this._bannerAreas.forEach((item) => {
            item.initMedia();
        });
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;
    }
}
